// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2cciS","logo":"style_logo__1Gy6w","logocontainer":"style_logocontainer__2P59J"};